import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_interaction_Select from 'ol/interaction/Select';
import { Util } from "../util";
import Map from '../map';
export class Select extends React.Component {
    constructor(props) {
        super(props);
        this.options = {
            addCondition: undefined,
            condition: undefined,
            layers: undefined,
            style: undefined,
            removeCondition: undefined,
            toggleCondition: undefined,
            multi: undefined,
            features: undefined,
            filter: undefined,
            wrapX: undefined,
            hitTolerance: undefined
        };
        this.events = {
            'change': undefined,
            'change:active': undefined,
            'propertychange': undefined,
            'select': undefined
        };
    }
    render() { return null; }
    componentDidMount() {
        if (this.props.instance) {
            this.interaction = this.props.instance;
        }
        else {
            let options = Util.getOptions(Object['assign'](this.options, this.props));
            this.interaction = new ol_interaction_Select(options);
        }
        this.context.mapComp.interactions.push(this.interaction);
        let olEvents = Util.getEvents(this.events, this.props);
        for (let eventName in olEvents) {
            this.interaction.on(eventName, olEvents[eventName]);
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            this.context.mapComp.map.removeInteraction(this.interaction);
            if (this.props.instance) {
                this.interaction = this.props.instance;
            }
            else {
                let options = Util.getOptions(Object['assign'](this.options, nextProps));
                this.interaction = new ol_interaction_Select(options);
            }
            this.context.mapComp.map.addInteraction(this.interaction);
            let olEvents = Util.getEvents(this.events, this.props);
            for (let eventName in olEvents) {
                this.interaction.on(eventName, olEvents[eventName]);
            }
        }
    }
    componentWillUnmount() {
        this.context.mapComp.map.removeInteraction(this.interaction);
    }
}
Select['contextTypes'] = {
    mapComp: PropTypes.instanceOf(Map),
    map: PropTypes.instanceOf(ol_Map)
};